(function () {
  if (window.PLAUD_ENABLE_COOKIE_BANNER_BUTTON_FLOAT === false) return;
  const CSS_VAR = '--cookie-banner-height';
  const HOST_SEL = '#cmpwrapper';
  const BOX_SEL = '#cmpbox';
  document.documentElement.style.setProperty(CSS_VAR, '0px');
  let bound = false;
  function getCmpBox() {
    const host = document.querySelector(HOST_SEL);
    const sr = host && host.shadowRoot;
    if (!sr) return null;
    return sr.querySelector(BOX_SEL);
  }
  function update() {
    const box = getCmpBox();
    const h = box ? Math.ceil(box.getBoundingClientRect().height || 0) : 0;
    document.documentElement.style.setProperty(CSS_VAR, h + 'px');
    console.log('h33', h);
  }
  function bindObservers() {
    if (bound) return;
    const host = document.querySelector(HOST_SEL);
    const sr = host && host.shadowRoot;
    const box = sr && sr.querySelector(BOX_SEL);
    if (!sr || !box) return;
    bound = true;
    new MutationObserver(update).observe(sr, { childList: true, subtree: true });
    new MutationObserver(update).observe(box, {
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden', 'aria-hidden']
    });
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(update);
      ro.observe(box);
    }
    let n = 0;
    (function rafSync() {
      update();
      n += 1;
      if (n < 20) requestAnimationFrame(rafSync);
    })();
  }
  update();
  bindObservers();
  new MutationObserver(() => {
    update();
    bindObservers();
  }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('load', () => { update(); bindObservers(); });
  window.addEventListener('resize', update);
})();
